<template>
  <div
    v-loading="loading"
    class="page-pg-action"
  >
    <el-form
      ref="xmInfo"
      class="c-form"
      :model="xmInfo"
      :inline="true"
      label-position="right"
      label-width="120px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col c-form__part-title"
          :span="24"
        >
          检测结论
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="检测结论说明"
            prop="pgqksm"
          >
            <template
              v-if="type!=='view'"
            >
              <el-input
                v-show="editJcjlsm"
                v-model="jcjlsm"
                type="textarea"
                rows="10"
                class="c-form__input"
                placeholder="请输入检测结论说明"
              />
              <textarea-read
                v-show="!editJcjlsm"
                v-model="xmInfo.jcjlsm"
                class="c-form__read u-line-20"
              />
              <k-button
                v-show="!editJcjlsm"
                btn-text="编辑"
                :auth-type="true"
                type="text"
                icon="kestrel-icon ki-edit"
                @click="()=>{editJcjlsm=true;jcjlsm=xmInfo.jcjlsm}"
              />
              <k-button
                v-show="editJcjlsm"
                btn-text="保存"
                :auth-type="true"
                type="text"
                icon="kestrel-icon ki-save"
                @click="handleSave()"
              />
              <k-button
                v-show="editJcjlsm"
                btn-text="取消"
                :auth-type="false"
                type="text"
                icon="kestrel-icon ki-close"
                @click="editJcjlsm=false"
              />
            </template>
            <template v-else>
              <textarea-read
                v-model="xmInfo.jcjlsm"
                class="c-form__read u-line-20"
              />
            </template>
          </el-form-item>
        </el-col>

        <el-col
          :span="24"
          class="c-form__col"
        >
          <el-form-item
            class="c-form__item"
            label="签到信息"
            prop="qdxxList"
          >
            <template v-if="xmInfo.qdxxList && xmInfo.qdxxList.length>0">
              <span class="c-form__read">{{ xmInfo.qdxxList[0].qdsj | date("yyyy-MM-dd HH:mm:ss") }} {{ xmInfo.qdxxList[0].qdrMc }} {{ xmInfo.qdxxList[0].qddz }}  </span>
              <el-popover
                v-if="xmInfo.qdxxList.length > 1"
                placement="right"

                trigger="click"
              >
                <div
                  v-for="(item,index) in xmInfo.qdxxList"
                  :key="index"
                >
                  <span class="c-form__read">{{ item.qdsj | date("yyyy-MM-dd HH:mm:ss") }} {{ item.qdrMc }} {{ item.qddz }}  </span>
                </div>
                <el-link
                  slot="reference"
                  type="primary"
                  :underline="false"
                >
                  详情
                </el-link>
              </el-popover>
            </template>
          </el-form-item>
        </el-col>
        <el-col
          :span="12"
          class="c-form__col"
        >
          <el-form-item
            class="c-form__item"
            label="检测结论"
            prop="zhpdjl"
          >
            <span class="c-form__read">{{ xmInfo.zhpdjlMc ? xmInfo.zhpdjlMc : '/' }}</span>
          </el-form-item>
        </el-col>
        <el-col
          :span="12"
          class="c-form__col"
        >
          <el-form-item
            class="c-form__item"
            label="检测提醒"
            prop="jctx"
          >
            <span class="c-form__read">
              检测项总计<span class="u-text-primary u-pd-lr-4">{{ xmInfo.jcxzs }}</span>条；
              已检<span class="u-text-success u-pd-lr-4">{{ xmInfo.yjcs }}</span>条；
              未检<span class="u-text-primary u-pd-lr-4">{{ xmInfo.wjcs }}</span>条。
              <!-- <el-link
                type="primary"
                :underline="false"
                @click="openNavTab({ name: 'viewJcx', params: { xmId: xmId, isRefresh: true} })"
              >
                查看详情
              </el-link> -->
            </span>
          </el-form-item>
        </el-col>
        <el-col
          :span="12"
          class="c-form__col"
        >
          <el-form-item
            class="c-form__item"
            label="报告编号"
            prop="bgbh"
          >
            <span
              class="u-mg-r-6 c-form__read u-text-primary"
            >{{ xmInfo.bgbh }}</span>
          </el-form-item>
        </el-col>
        <el-col
          :span="12"
          class="c-form__col"
        >
          <el-form-item
            class="c-form__item"
            label="检测报告"
            prop="jcbgdz"
          >
            <k-button
              v-if="xmInfo.jcbgdz"
              btn-text="查看检测报告"
              :auth-type="false"
              plain
              type="primary"
              icon="kestrel-icon ki-file-pdf"
              :disabled="xmInfo.previewPdf"
              @click="(e)=>$utils.previewPdf(e,xmInfo.jcbgdz,xmInfo)"
            >
              <i
                v-show="xmInfo.previewPdf"
                class="el-icon-loading"
              />
            </k-button>
            <span
              v-else
              class="c-form__read"
            >未生成报告</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template>
      <div
        class="o-part-title"
      >
        <span
          class="u-mg-r-10"
        >
          建筑信息
        </span>
        <k-button
          v-if="type!=='view'"
          btn-text="新增"
          :auth-type="true"
          type="primary"
          plain
          icon="kestrel-icon ki-plus"
          @click="handleDialog('addJz',{xmid: xmId})"
        />
      </div>

      <k-table
        ref="kTable"
        :table-column="jzxxTableColumn"
        :data="jzxxList"
        :pagination-show="false"
      >
        <template
          #jzwmc="scope"
        >
          <el-link
            type="primary"
            @click="handleDialog('viewJz', {id: scope.row.jzwId})"
          >
            {{ scope.row.jzwmc }}
          </el-link>
        </template>
        <el-table-column
          v-if="type!=='view'"
          prop="enabled"
          label="操作"
          width="120"
          align="center"
          fixed="right"
        >
          <template
            slot-scope="scope"
          >
            <k-button
              btn-text="编辑"
              :auth-type="true"
              type="text"
              plain
              @click="handleDialog('editJz',{id: scope.row.jzwId})"
            />
            <k-button
              btn-text="删除"
              :auth-type="true"
              type="text"
              @click="handleDelJz(scope.row, scope.$index)"
            />
          </template>
        </el-table-column>
      </k-table>
    </template>

    <!-- 添加/修改 建筑信息 -->
    <update-jzxx-dialog
      v-if="showDialogName === 'editJz' || showDialogName === 'addJz'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="queryJzxx()"
    />

    <!-- 添加/修改 建筑信息 -->
    <view-jzxx-dialog
      v-if="showDialogName === 'viewJz'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
    />
  </div>
</template>

<script>
import { xmglService } from '../xmgl.service.js';
import { jzwService } from '../jzw/jzw.service.js';
export default {
  name: 'ActionInfo',
  components: {
    updateJzxxDialog: () => import('../jzw/updateDialog'),
    viewJzxxDialog: () => import('../jzw/viewDialog')
  },
  props: {
    xmInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    type: {
      type: String,
      default: 'view'
    }
  },
  data () {
    return {
      loading: false,
      xmId: null,
      jzxxList: [],
      jzxxTableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'jzwmc', slotName: 'jzwmc', label: '建筑名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'gd', label: '高度（m）', align: 'left', minWidth: '80', type: 'text' },
        { key: 'mj', label: '面积（m²）', align: 'left', minWidth: '80', type: 'text' },
        { key: 'dscs', label: '地上层层数', align: 'left', width: '80', type: 'text' },
        { key: 'dxcs', label: '地下层层数', align: 'left', width: '80', type: 'text' }
      ],

      fd: {
        id: null,
        pgfg: null
      },

      editJcjlsm: false,
      jcjlsm: null,

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 end */
    };
  },
  methods: {
    queryJzxx () {
      const _this = this;
      jzwService.queryJzw({
        pageSize: 600,
        pageNo: 1,
        xmId: _this.xmId
      })
        .then(rsp => {
          _this.jzxxList = rsp.data.rows;
        })
        .catch(err => {
          console.error('获取建筑信息错误', err);
        });
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDelJz (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此条建筑信息记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        jzwService.deleteJzw(_row.jzwId)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.queryJzxx();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    handleSave () {
      // 检测结论检验
      const jcjg = this.jcjlsm;
      if (jcjg && jcjg.replace(/\s/g, '').length === 0) {
        this.$message({
          message: '【检测结论说明】不能全为空格！',
          type: 'warning'
        });
        return;
      }
      if (jcjg && jcjg.length > 3000) {
        this.$message({
          message: '【检测结论说明】长度不能超出3000位！',
          type: 'warning'
        });
        return;
      }
      this.loading = true;
      xmglService.saveJcjl({ xmId: this.xmInfo.xmId, jcjlsm: this.jcjlsm })
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.xmInfo.jcjlsm = this.jcjlsm;
          this.editJcjlsm = false;
        })
        .catch(err => {
          console.error('修改检测结论说明失败！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 跳转窗口
     * @author: cgh
     */
    handleDialog (_name, params) {
      this.showDialogName = _name;
      this.dialogParams = params;
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.queryJzxx();
  }
};
</script>
